import { Joi, actionCreator, objectSchemaOf } from '../helpers';
import { SYSTEM_INPUT } from './topics';

export const ASLEEP = 'SYSTEM/ASLEEP' as const;

export interface IAsleepActionPayload {
  consoleId: string;
}

export const asleepActionPayloadSchema = objectSchemaOf<IAsleepActionPayload>({
  consoleId: Joi.string().required(),
});

export interface IAsleepAction {
  type: typeof ASLEEP;
  payload: IAsleepActionPayload;
}

export const asleepActionSchema = objectSchemaOf<IAsleepAction>({
  type: Joi.string().required().valid(ASLEEP),
  payload: asleepActionPayloadSchema.required(),
});

export const asleep = actionCreator({
  type: ASLEEP,
  topic: SYSTEM_INPUT,
  schema: asleepActionSchema,
});
